import React from 'react';

import { Caption } from '@depop/web-thrift-ui/Typography';
import clsx from 'clsx';

import styles from './styles.module.css';

// data-testid is used in the id for aria-describedby
type Props = {
  'data-testid'?: string;
} & React.ComponentProps<typeof Caption>;

export function ErrorMessage({
  children,
  className,
  'data-testid': dataTestId,
  ...rest
}: Props) {
  return (
    <Caption
      variant="lg-regular"
      id={dataTestId}
      role="alert"
      aria-live="polite"
      className={clsx(styles.errorMessage, className)}
      {...rest}
    >
      {children}
    </Caption>
  );
}
